import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { IBreadcrumb } from '../types/breadcrumb';

export const mapBreadcrumbs = (promosResponse: ISearchPromosV2ResponseSchema): IBreadcrumb[] => {
  return promosResponse.breadcrumbs || [];
};
